<template><div><h1 id="warenrucknahme-statistik" tabindex="-1"><a class="header-anchor" href="#warenrucknahme-statistik"><span>Warenrücknahme-Statistik</span></a></h1>
<p>Warenrücknahme-Statistik</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste der Artikel, für die eine Warenrücknahme gebucht wurde. Die Liste enthält kumulative Werte für jedes Ertragskonto und jeden Artikel und weist ein Gesamttotal pro Ertragskonto aus. Eingegrenzt wird nach Zeitraum [ErfassDatum von - bis].</p>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Retouren, die über die Auftragspositionen eingebucht wurden, erscheinen in dieser Statistik nicht.</p>
</div>
<p>Pfad: <code v-pre>Verkauf → Auswertungen → Warenrücknahme-Statistik</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von ErfassDatum</dt>
<dd>Anfangsdatum, Muss-Eingabe, inklusive</dd>
<dt>bis ErfassDatum</dt>
<dd>Enddatum, Muss-Eingabe, inklusive</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Ertragskonto</td>
<td>Ertragskonto / Kostenstelle</td>
</tr>
<tr>
<td>Artikel</td>
<td>Artikelnummer, Artikelbezeichnung</td>
</tr>
<tr>
<td>Anzahl Artikel</td>
<td>Anzahl pro Artikel</td>
</tr>
<tr>
<td>Umsatz Brutto</td>
<td>Brutto-Umsatz pro Artikel</td>
</tr>
<tr>
<td>Umsatz Netto</td>
<td>Netto-Umsatz = minus gewährte Rabatte</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Umsätze von Warenrücknahmen mit Erfassungsdatum: 01.01.1997 - 11.11.1997</span>
<span class="line"></span>
<span class="line">                                        Anzahl          Umsatz    Umsatz Netto</span>
<span class="line">Ertragskonto/Artikel                   Artikel          Brutto      (- Rabatt)</span>
<span class="line">----------------------------------- ---------- --------------- ---------------</span>
<span class="line">Konto 1111.1 7777</span>
<span class="line">1B KALENDER 1991                             5          126.00           61.00</span>
<span class="line">2 KALENDER 1992                              1           46.55           22.55</span>
<span class="line">2B NICHT BENUTZT                             1           66.90           32.40</span>
<span class="line">2E NICHT BENUTZT                             1           66.90           32.40</span>
<span class="line">2F NICHT BENUTZT                             1          183.20           88.70</span>
<span class="line">Total für Konto 1111.1 7777                             489.55          237.05</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Für Ertragskonto 1111.1, Kostenstelle 7777 wurden im Zeitraum 1.1.97 bis 11.11.97 fünf &quot;Kalender 1991&quot; (Artikelnummer 1B) als Warenrücknahme gebucht. Der Bruttoumsatz (gemäss Verkaufspreis im Artikelstamm) betrug 126 Franken, effektiv betrug der Umsatz nur 61 Franken, da Rabatte gewährt wurden.</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Spendeartikel werden in dieser Statistik nicht mitgezählt.</p>
</div>
</div></template>


